import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import EventAgendaCTA from '../../_molecules/EventAgendaCTA';
import EventAgendaEmpty from '../../_molecules/EventAgendaEmpty';
import EventDayTabs from '../../_molecules/EventDayTabs';
import CalendarPlusIcon from '@icons/CalendarPlusIcon';
import Button from '@atoms/Button';
import EventAgendaCard from '@molecules/EventAgendaCard';
import LoadingArea from '@molecules/LoadingArea';
import { DividerLightGreyStyled } from '@styled';

import { EventDetailProvider, eventDetailSubviews } from '../../pages/MyIcsc/Events/EventDetailProvider';
import useEventSessions from '../../../hooks/useEventSessions';
import useSavedSessionFilters from '../../../hooks/algoliaFilters/useSavedSessionFilters';
import { mapSearchSessionToProps } from '@general/transforms/session.transform';
import useEventSessionsTabsStartDate from '../../../hooks/useEventSessionsTabsStartDate';

// const SyncToCalendarContainer = styled.div`
//     display: flex;
//     justify-content: center;
//     margin-top: 48px;
// `;

// const SyncToCalendarButton = styled(Button)`
//     align-items: center;
//     display: flex;

//     span {
//         margin-left: 10px;
//     }
// `;

// const SyncToCalendarText = styled.span`
//     margin-left: 10px;
// `;

const MyEventAgenda = () => {
    const { event, setCurrentSubview } = useContext(EventDetailProvider);
    const { eventSessionsTabsStartDate } = useEventSessionsTabsStartDate(event);
    const [activeDay, setActiveDay] = useState(eventSessionsTabsStartDate);
    const { filters } = useSavedSessionFilters({ eventCode: event.event_code, activeDay });
    const { eventSessions } = useEventSessions({ filters });
    const history = useHistory();

    useEffect(() => {
        setActiveDay(eventSessionsTabsStartDate);
    }, [eventSessionsTabsStartDate]);

    if (!eventSessions) {
        return <LoadingArea />;
    }

    return (
        <div>
            <EventDayTabs
                eventStartDate={eventSessionsTabsStartDate}
                eventEndDate={event.meeting_end_time}
                activeDay={activeDay}
                onDayChange={setActiveDay}
            >
                {eventSessions.length > 0 && (
                    <>
                        <div className="mb-1rem mt-1rem">
                            <EventAgendaCTA />
                        </div>

                        <DividerLightGreyStyled className="mb-0" />

                        {eventSessions.map(session => (
                            <EventAgendaCard
                                key={session.objectID}
                                agendaItem={{
                                    type: 'SESSION',
                                    ...mapSearchSessionToProps({
                                        hit: session,
                                        isFavorite: true,
                                    }),
                                }}
                            />
                        ))}
                    </>
                )}

                {eventSessions.length === 0 && (
                    <EventAgendaEmpty
                        onSessionsClick={() => {
                            setCurrentSubview(eventDetailSubviews.SESSIONS.key);
                            window.history.replaceState(null, '', `/my-icsc/events/${event.event_code}/sessions`);
                        }}
                        onAvailabilityClick={() => {
                            setCurrentSubview(eventDetailSubviews.AVAILABILITY.key);
                            window.history.replaceState(null, '', `/my-icsc/events/${event.event_code}/availability`);
                        }}
                        onMatchesClick={() => {
                            history.push('/my-icsc/connections/matches');
                        }}
                    />
                )}

                {/*
                {agendaItems.length > 0 && (
                    <SyncToCalendarContainer className="">
                        <SyncToCalendarButton buttonClasses="d-flex align-items-center">
                            <>
                                <CalendarPlusIcon color="white" />
                                <SyncToCalendarText>Sync to Calendar</SyncToCalendarText>
                            </>
                        </SyncToCalendarButton>
                    </SyncToCalendarContainer>
                )}
                */}
            </EventDayTabs>
        </div>
    );
};

MyEventAgenda.propTypes = {
    //
};

export default MyEventAgenda;
